import { QueryKey } from "@tanstack/react-query";

export const sessionPackQueryKeys = {
  all: () => ['session-pack'] as const,
  list: (filters: Readonly<{ [k: string]: any }>) => [...sessionPackQueryKeys.all(), { filters }] as QueryKey,
  summary: (params?: Readonly<{ [k: string]: any }>) => [...sessionPackQueryKeys.all(), 'summary', params] as QueryKey,
  details: (sessionPackId?: number) => [...sessionPackQueryKeys.all(), sessionPackId] as QueryKey,
};
